module.exports = __webpack_public_path__ + "31288f8bff795bade4ab94bfa63b16ac.pdf";